import React, {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';

import service from '@/services/index';
import { isBase64Image } from '@/utils/util';
interface Props {
  alias: string;
  setSize: Dispatch<SetStateAction<[number, number] | null>>;
  setFileSize: Dispatch<SetStateAction<number | null>>;
}

const MARGIN = 200;

const ImageViewer = ({ alias, setSize, setFileSize }: Props) => {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const [url, setUrl] = useState<string>('');
  const imgRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      let width = image.naturalWidth;
      let height = image.naturalHeight;
      if (image.naturalWidth > window.innerWidth) {
        width = window.innerWidth - MARGIN;
        height =
          (image.naturalHeight * window.innerWidth) / image.naturalWidth -
          MARGIN;
      }
      if (image.naturalHeight > window.innerHeight) {
        height = window.innerHeight - MARGIN;
        width =
          (image.naturalWidth * window.innerHeight) / image.naturalHeight -
          MARGIN;
      }

      setWidth(width);
      setHeight(height);
      setSize([width, height]);
    };

    if (isBase64Image(alias)) {
      image.src = alias;
      if (imgRef.current) {
        imgRef.current.src = alias;
      }
    } else {
      service.attachment.getAttachment(alias, 'image').then((data) => {
        const fileUrl = URL.createObjectURL(data);
        setUrl(fileUrl);
        image.src = fileUrl;
        if (imgRef.current) {
          imgRef.current.src = fileUrl;
        }
      });
    }

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [setFileSize, setSize, alias, imgRef]);

  return (
    <Wrapper>
      <img
        ref={imgRef}
        width={`${width}px`}
        height={`${height}px`}
        alt="image"
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export default ImageViewer;
